import * as React from 'react';
import ContentTile from './ContentTile';

export default () => (
  <ContentTile color="#00D2D6" tint={0.1}>
    {/* Data moving through a step: speed lines into a circle, an arrow inside. */}
    <circle cx="14" cy="12" r="7" />
    <path d="M9 7H4M6 12H2M9 17H4M18 12h-6M15 9l3 3-3 3" />
  </ContentTile>
);
